<template>
    <div class="card-block" style="position:relative; top: 75px" @keypress.enter="validateAndSignInFila">
      <h2>Entrar NxSenhas</h2>
      <p class="text-muted">Digite as informações abaixo para acessar</p>

      <div class="input-group mb-3">
        <span class="input-group-addon"><i class="icon-user"></i></span>
        <b-form-input type="text"
                      id="usernameFila"
                      name="usernameFila"
                      :placeholder="errorsVee.has('usernameFila') ? errorsVee.first('usernameFila') : $lang.Login.Username"
                      v-model="usernameFila"
                      v-validate="'required'"
                      aria-describedby="usernameFilaErrorFeedback"
                      :state="errorsVee.has('usernameFila') ? false : getValidationState('usernameFila')"
                      @blur.native="getValidationState('usernameFila')">
        </b-form-input>
      </div>

      <div class="input-group mb-3">
        <span class="input-group-addon"><i class="icon-lock"></i></span>
        <b-form-input :type="showPasswordFila ? 'text' : 'password'"
                      class="password__eye__input"
                      id="passwordFila"
                      name="passwordFila"
                      @input="inputouPasswordFila"
                      :placeholder="errorsVee.has('passwordFila') ? errorsVee.first('passwordFila') : $lang.Login.Password"
                      v-model="passwordFila"
                      data-vv-as="senha"
                      v-validate="'required'"
                      aria-describedby="passwordFilaErrorFeedback"
                      :state="errorsVee.has('passwordFila') ? false : getValidationState('passwordFila')"
                      @blur.native="getValidationState('passwordFila')">
        </b-form-input>
        <b-button :class="[showPasswordFila ? 'fas fa-eye-slash' : 'fas fa-eye', typedFila ? 'password__eye__btn__typed' : '']"
                  variant="outline-secondary"
                  @click="togglePasswordFila"
                  class="password__eye__btn">
        </b-button>
      </div>

      <div class="row">
        <div class="col-12 text-right">
          <button type="button" class="btn btn-third px-4" @click="validateAndSignInFila"><i class="fas fa-sign-in-alt"></i> {{$lang.Login.ButtonEnter}}</button>
        </div>
      </div>
    </div>
  </template>

<script>
import { loading } from '@/shared/utils/UIHelper'

export default {
  name: 'LoginFila',
  data () {
    return {
      hasLogo: null,
      usernameFila: undefined,
      passwordFila: undefined,
      typedFila: false,
      showPasswordFila: false
    }
  },
  created () {
    loading.pop()
  },
  methods: {
    inputouPasswordFila () {
      this.typedFila = true
    },
    togglePasswordFila () {
      this.showPasswordFila = !this.showPasswordFila
    },
    validateAndSignInFila () {
      this.passwordFila = this.passwordFila.trim()
      this.$emit('LoginFila', this.usernameFila, this.passwordFila)
    },
    getValidationState (fieldName) {
      const field = this.$validator.fields.find({ name: fieldName })

      if (!field) return null

      const isDirty = field.flags.dirty
      const isValid = !this.errorsVee.has(fieldName)
      return isDirty ? isValid : null
    },
    onresetPasswordFila () {
      this.$emit('ResetPasswordFila')
    }
  }
}
</script>

  <style>
  .password__eye__btn {
    border: none;
    border-radius: 0;
    position: absolute;
    right: 0;
    z-index: 5;
    transition: .2s ease-in-out;
  }

  .password__eye__btn__typed {
    right: 1rem !important;
    transition: .2s ease-in-out;
  }

  .password__eye__btn:hover, .password__eye__btn:active, .password__eye__btn:focus, .password__eye__btn:focus-visible {
    background: none !important;
    border-left: none !important;
    box-shadow: none;
    border: none;
  }
  </style>



// WEBPACK FOOTER //
// src/views/public/auth/login/loginFila.vue